import { Controller } from '@hotwired/stimulus';

// Use an input that will be focused on render.
// Ex: basic input usage
//   <input
//     type="text"
//     name="body"
//     placeholder="What are your thoughts?"
//     data-controller="focused-input"
//   >
// Ex: focusing at the end of any existing content
//   <textarea
//     name="body"
//     placeholder="What are your thoughts?"
//     rows="1"
//     data-controller="focused-input"
//     data-focused-input-focus-at-end-of-input-value="true"
//   ><%= view.body %></textarea>

class FocusedInputController extends Controller {
  static values = {
    focusAtEndOfInput: { type: Boolean, default: false },
  };

  connect() {
    try {
      if (this.element) {
        this.element.focus(); // eslint-disable-line no-unused-expressions

        if (this.focusAtEndOfInputValue) {
          const { element } = this;
          const appendValue = element.value.trim() === '' ? '' : ' ';
          setTimeout(() => {
            element.value += appendValue;
          }, 0);
        }
      }
    } catch (error) {
      // Purposefully do nothing.
    }
  }
}

export default FocusedInputController;
